module.exports = require('crypto');


//////////////////
// WEBPACK FOOTER
// ./~/randomhex/src/crypto.js
// module id = 608
// module chunks = 0